/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React from "react"
import { useTheme } from "@cd2/theme"
import { IxRef } from "../types/utils"

interface IProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  xRef?: IxRef<HTMLDivElement>
  children: React.ReactNode
  border?: boolean
  secondary?: boolean
  heading?: string
}
export function Card({ border, secondary, xRef, heading, children, ...props }: IProps) {
  const { borderRadius, colors } = useTheme()

  return (
    <div
      ref={xRef}
      css={css`
        padding: 16px;
        border-radius: ${borderRadius}px;
        background: ${secondary ? "#f4f6f7" : "white"};
        ${secondary
          ? ""
          : "box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);"}
        ${border ? `border: 1px solid ${colors.formBorderColor};` : ""}
      `}
      {...props}
    >
      {heading && (
        <div
          css={css`
            margin: -16px;
            margin-bottom: 16px;
            border-bottom: 1px solid ${colors.formBorderColor};
            padding: 16px;

            h3 {
              margin: 0;
              font-size: 1.25rem;
              font-weight: 500;
            }
          `}
        >
          <h3>{heading}</h3>
        </div>
      )}
      {children}
    </div>
  )
}
